<script setup>
import debounce from "just-debounce-it";

const { value, className } = defineProps({
  value: Array,
  className: String | null,
});

const emits = defineEmits(["onChange"]);

const selected = ref([]);
const selectedOptions = ref([]);
const debounceFilter = ref();

const updateFilter = (keyword) => {
  debounceFilter.value = keyword;
};

const debouncedInput = debounce(updateFilter, 600);

const { data: universities } = usePublicFetch("universities", {
  key: "universities",
  lazy: true,
  query: { name: debounceFilter },
  watch: [debounceFilter],
  transform(universities) {
    return universities?.data;
  },
});

const onSelect = (value) => {
  emits("onChange", value);
  selectedOptions.value = universities.value.filter((uni) =>
    value.includes(uni.id),
  );
};

onMounted(async () => {
  if (value?.length) {
    selected.value = value;
    const promises = value.map((id) =>
      useApiFetch(`universities/${id}`, {
        key: `university-by-id-${id}`,
        transform(university) {
          return university?.data;
        },
      }),
    );
    const results = await Promise.all(promises);
    selectedOptions.value = results.map((res) => res?.data).filter(Boolean);
  }
});
</script>

<template>
  <MultiSelect
    v-model="selected"
    :options="universities"
    filter
    optionLabel="name"
    optionValue="id"
    placeholder="Select universities"
    display="chip"
    size="small"
    :maxSelectedLabels="1"
    :disabled="isDisabled"
    @filter="(e) => debouncedInput(e.value)"
    @change="(e) => onSelect(e.value)"
  >
  </MultiSelect>
</template>
